import React, { useState } from "react";
import { InboxOutlined } from "@ant-design/icons";
import { Alert, Upload } from "antd";

const { Dragger } = Upload;

export function ModalUpload({ onClose, uploadProps }) {
  // 1. Criar um estado local para controlar a lista de arquivos
  const [fileList, setFileList] = useState([]);

  const handleChange = (info) => {
    // 2. Atualiza o estado conforme o upload progride
    let newFileList = [...info.fileList];

    // Exemplo: Limpar a lista automaticamente se o status for 'done'
    if (info.file.status === 'done') {
      // Se você quiser que o arquivo suma da lista assim que terminar:
      setFileList([]); 
      // Caso contrário, mantenha a lista e limpe apenas em um botão de "Salvar" ou no OnClose
    } else {
      setFileList(newFileList);
    }
  };

  return (
    <>
      <div style={{ marginBottom: 10 }}>
        <Alert 
          message="Instruções"
          description="Selecione o arquivo que desejar disponibilizar para o cliente."
          type="info"
          showIcon 
        />
      </div>

      <div>
        <Dragger 
          {...uploadProps} 
          fileList={fileList} // 3. Vincula o estado ao componente
          onChange={handleChange} // 4. Monitora as mudanças
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Clique ou arraste o arquivo aqui
          </p>
          <p className="ant-upload-hint">
            Suporte para upload de arquivos PDF, PNG, JPEG etc. Imagens serão
            convertidas automaticamente para PDF.
          </p>
        </Dragger>
      </div>
    </>
  );
}

export default ModalUpload;
